"use client";

import Link from "@/components/LocalizedLink";
import type { ReactElement, ReactNode } from "react";
import { trackEvent } from "@/lib/analytics";

interface LocationContactLinkProps {
  href: string;
  popId: string;
  city: string;
  surface: "hero" | "footer";
  className?: string;
  children: ReactNode;
}

export function LocationContactLink({
  href,
  popId,
  city,
  surface,
  className,
  children,
}: LocationContactLinkProps): ReactElement {
  return (
    <Link
      href={href}
      onClick={() =>
        trackEvent("location_contact_sales", {
          location: popId,
          city,
          surface,
        })
      }
      className={className}
    >
      {children}
    </Link>
  );
}
